import { GoalTargets } from './goal-targets';
import { AnalyticalComponents } from '../interfaces/analytical-components.enum';
import { DashboardSettingsDto } from '../interfaces/dashboard-settings.dto';

export class DashboardSettings {
  public hiddenComponents: Array<AnalyticalComponents>;

  public static fromDto(
    dashboardSetting: DashboardSettingsDto
  ): DashboardSettings {
    let settings: DashboardSettings;

    if (!dashboardSetting) {
      settings = new DashboardSettings(new GoalTargets(0, 0, 0), [], false);
      return settings;
    }

    settings = new DashboardSettings(
      new GoalTargets(
        dashboardSetting.targets.revenueTarget,
        dashboardSetting.targets.customerTarget,
        dashboardSetting.targets.receiptTarget
      ),
      dashboardSetting.closingDays,
      dashboardSetting.taxIncl
    );

    settings.hiddenComponents = dashboardSetting.hiddenComponents || [];
    return settings;
  }

  public static toDto(
    dashboardSettings: DashboardSettings
  ): DashboardSettingsDto {
    return <DashboardSettingsDto>{
      targets: {
        receiptTarget: dashboardSettings.goalTargets.receiptTarget,
        customerTarget: dashboardSettings.goalTargets.customerTarget,
        revenueTarget: dashboardSettings.goalTargets.revenueTarget
      },
      closingDays: dashboardSettings.closingDays,
      taxIncl: dashboardSettings.taxIncl,
      hiddenComponents: dashboardSettings.hiddenComponents || []
    };
  }

  public static getDefaultDashboardSettings(): DashboardSettings {
    return new DashboardSettings(new GoalTargets(0, 0, 0), [], false);
  }

  constructor(
    public goalTargets: GoalTargets,
    public closingDays: Array<number>,
    public taxIncl: boolean
  ) {
    this.hiddenComponents = [];
  }
}
